'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { PublicContactModal } from './public-contact-modal';

// The only interactive part of the public landing page, so it owns the modal
// state on its own and lets the page around it stay a Server Component.
export function BookDemoButton() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <Button
        size="lg"
        className="h-12 cursor-pointer rounded-2xl border border-white/70 bg-slate-900/90 px-7 text-base font-semibold text-white shadow-[0_18px_45px_rgba(15,23,42,0.20)] backdrop-blur-sm transition-colors hover:bg-slate-900"
        onClick={() => setIsContactOpen(true)}
      >
        Book a Demo
      </Button>

      <PublicContactModal open={isContactOpen} onOpenChange={setIsContactOpen} />
    </>
  );
}
